export default "__VITE_ASSET__BxpvtAnp__"